import React, { useState } from "react";
import { useSelector } from "react-redux";
import styles from "./PackageItems.module.css";

export default function PackageItems() {
    const packageId = useSelector(state => state.visualizer.activePackageId);
    const packages = useSelector(state => state.visualizer.packagesData);
    const [selectedProductId, setSelectedProductId] = useState(null);
    
    const selectedPackage = packages[packageId];

    function getPackageNameById(packageId) {
        const foundPackage = packages["packages"].find(pkg => pkg.id === packageId);
        return foundPackage ? foundPackage.name : null;
    }

    function handleItemClick(productId) {
        setSelectedProductId(productId);
    }

    const packageItems = [];
    if (selectedPackage != null) {
        selectedPackage.forEach((product, index) => {
            if (product.active) {
                packageItems.push(
                    <li
                        key={index}
                        className={index === selectedProductId ? 'selected' : ''}
                        onClick={() => handleItemClick(index)}
                    >
                        <img 
                            src={product.surface.includes('Cabinet') ?
                                //is a cabinet
                                 `https://core2render.chameleonpower.com/cham/getImage.ashx?spec=!${product.sel}&type=base&extra=(focus=(@SIZE/@IMAGE[1][RES][X]/1in))&Size=250&form=png` :
                                 // not a cabinet
                                `https://core2render.chameleonpower.com/cham/getImage.ashx?spec=!${product.sel}&type=prod&extra=(focus=300)&Size=250`} 
                            alt={product.name} 
                            width="100" height="115"
                        />
                        <p>{product.surface}</p>
                        <p>{product.name}</p>
                        <p>{product.subName}</p>
                    </li>
                );
            }
        });
    }

    return (
        <div className={styles.content}>
            {packageId !== undefined && selectedPackage !== undefined && (
                <>
                    <div className={styles.header}>
                         <p>Products in {getPackageNameById(packageId)}</p>
                    </div>
                    <div className={styles.ulParent}>
                        <ul>
                            {packageItems}
                        </ul>
                    </div>
                </>
            )}
        </div>
    );
}
